module.exports = __webpack_public_path__ + "img/horizontal_3_5_5.b31de1c8.png";